

























import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { UpdatePlatformAccount } from '@/api'
import { Message } from 'element-ui'
import { ElForm } from 'element-ui/types/form'
import { VImageUpload } from '@/components/upload'
import constant from '@/utils/constant'

@Component({
  components: {
    VImageUpload,
  },
})
export default class CreatePlatformDialog extends Vue {
  private show = false
  private data: any = {}
  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    name: [this.requiredRule],
    rolerole: [this.requiredRule],
    status: [this.requiredRule],
  }
  private constant = constant

  @Emit('close')
  private close() {
    const f = this.$refs.form as ElForm
    f.resetFields()
    this.show = false
    this.data ={}
  }
  public open(param: any) {
    this.show = true
    this.data = {...param}
  }

  public async save() {
    const f = this.$refs.form as ElForm
    f.validate(async (success: boolean) => {
      if (!success) {
        return
      }
      await UpdatePlatformAccount(this.data)
      Message.success('保存成功')
      this.close()
    })
  }
}
